import React, { createContext, useContext, useState, useCallback } from "react";

interface AppointmentContextType {
  // Trigger para actualizar citas
  appointmentUpdateTrigger: number;

  // Función para notificar que las citas han cambiado
  triggerAppointmentUpdate: () => void;

  // Estado específico para next appointment en dashboard
  shouldUpdateNextAppointment: boolean;
  setShouldUpdateNextAppointment: (value: boolean) => void;
}

const AppointmentContext = createContext<AppointmentContextType | undefined>(
  undefined
);

export const AppointmentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [appointmentUpdateTrigger, setAppointmentUpdateTrigger] =
    useState<number>(0);
  const [shouldUpdateNextAppointment, setShouldUpdateNextAppointment] =
    useState<boolean>(false);

  const triggerAppointmentUpdate = useCallback(() => {
    setAppointmentUpdateTrigger((prev) => prev + 1);
    setShouldUpdateNextAppointment(true);
  }, []);

  const value: AppointmentContextType = {
    appointmentUpdateTrigger,
    triggerAppointmentUpdate,
    shouldUpdateNextAppointment,
    setShouldUpdateNextAppointment,
  };

  return (
    <AppointmentContext.Provider value={value}>
      {children}
    </AppointmentContext.Provider>
  );
};

export const useAppointmentContext = (): AppointmentContextType => {
  const context = useContext(AppointmentContext);
  if (context === undefined) {
    throw new Error(
      "useAppointmentContext must be used within an AppointmentProvider"
    );
  }
  return context;
};
